/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniPathParams,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniQueryParams,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini400,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini401,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini500,
} from "../../types/individualPaymentVanzoliniController/PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini } from "../../clients/individualPaymentVanzoliniController/postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini.ts";

export const postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniMutationKey =
  () =>
    [
      {
        url: "/api/v1/individualpayment/parcels/:parcelId/invoice-future-payment-vanzolini",
      },
    ] as const;

export type PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniMutationKey =
  ReturnType<
    typeof postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniMutationKey
  >;

export function postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniMutationKey();
  return mutationOptions<
    PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini400
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini401
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniPathParams["parcelId"];
      params?: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniQueryParams;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ parcelId, params }) => {
      return postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini(
        parcelId,
        params,
        config,
      );
    },
  });
}

/**
 * @description Variante do InvoiceFuturePayment com e-mail de destino. O envio do e-mail é feito pela camada de notificação (corpo/e-mail gravados). Migrado do legado IndividualPayment/InvoiceFuturePaymentVanzolini. **(Requer Authorization para autenticação)**
 * @summary Antecipa a emissão da NF no pagamento futuro com e-mail (Vanzolini) (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/invoice-future-payment-vanzolini}
 */
export function usePostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini400
        | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini401
        | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniPathParams["parcelId"];
        params?: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniQueryParams;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniMutationKey();

  const baseOptions =
    postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini400
        | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini401
        | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniPathParams["parcelId"];
        params?: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniQueryParams;
      },
      TContext
    >;

  return useMutation<
    PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini400
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini401
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniPathParams["parcelId"];
      params?: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniQueryParams;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini400
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini401
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniPathParams["parcelId"];
      params?: PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniQueryParams;
    },
    TContext
  >;
}
